import axios from 'axios';
import { QueryClient, useQuery } from '@tanstack/react-query';

function useAnswersForQuestionId(questionId) {
  return useQuery({
    queryKey: ['answers', questionId],
    queryFn: async () => {
      const { data } = await axios.get(`/api/participants/question/${questionId}`);

      return data;
    },
    refetchInterval: 60_000,
  });
}

function useParticipantAnswersForQuestionId(questionId, enabled = false) {
  return useQuery({
    queryKey: ['participant-answers', questionId],
    queryFn: async () => {
      const { data } = await axios.get(`/api/participants/question/${questionId}/participants`);

      return data;
    },
    enabled,
    refetchInterval: 60_000,
  });
}

const QUERY_CLIENT = new QueryClient();

export {
  useAnswersForQuestionId,
  useParticipantAnswersForQuestionId,
  QUERY_CLIENT,
};